import { useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from '../pages/Loader'

const TripUpdateFlight = ({trip, flight, onAddFlight}) => {

    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [departure_airport, setDepartureAirport] = useState(flight.departure_airport || '') 
    const [departure_airport_code, setDepartureAirportCode] = useState(flight.departure_airport_code || '')
    const [arrival_airport, setArrivalAirport] = useState(flight.arrival_airport || '') 
    const [arrival_airport_code, setArrivalAirportCode] = useState(flight.arrival_airport_code || '')
    const [departure_date, setDepartureDate] = useState(flight.departure_date || '') 
    const [departure_time, setDepartureTime] = useState(flight.departure_time || '') 
    const [arrival_date, setArrivalDate] = useState(flight.arrival_date || '')
    const [arrival_time, setArrivalTime] = useState(flight.arrival_time || '')
    const [flight_number, setFlightNumber] = useState(flight.flight_number || '')
    const [seat_number, setSeatNumber] = useState(flight.seat_number || '')
    const [additional_notes, setAdditionalNotes] = useState(flight.additional_notes || '')
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)


    if (!flight) return <Loader />

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!user) {
            return
        }
        if (!flight) {
            return
        }
        setIsLoading(true)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight/`, {
            method: 'PATCH',
            body: JSON.stringify({trip_id: trip._id, flight_id: flight._id, departure_airport, departure_airport_code, arrival_airport, arrival_airport_code, departure_date, departure_time, arrival_date, arrival_time, flight_number, seat_number, additional_notes}),
            headers: {'Content-Type': 'application/json'},
            credentials: 'include'
        })
        const json = await response.json() 
        
        if (!response.ok) {
            setError(json.error)
            setIsLoading(false)
        }

        if (response.ok) {
            setError(null)
            console.log('Flight edited')
            dispatch({type: 'UPDATE_FLIGHT', payload: json})
            setIsLoading(false)
            onAddFlight("details")
        }
    
    }   

    if (isLoading) {
        return <Loader />
    }

    return (
        <form className="add-flight-page" onSubmit={handleSubmit}>
            <h3>Update Flight</h3>
            <div className="flight-inputs">
                <div className="two-input-container">
                    <div className="input-container">
                        <label htmlfor="departure_airport" class="airport-name-input">* Departure Airport</label>
                        <input id="departure_airport" class="airport-name-input" type="text" onChange={(e) => setDepartureAirport(e.target.value)} value={departure_airport} />
                    </div>
                    <div className="input-container">
                        <label htmlfor="departure_airport_code" class="airport-code-input">* Departure Airport Code</label>
                        <input id="departure_airport_code" class="airport-code-input code-text" type="text" onChange={(e) => setDepartureAirportCode(e.target.value)} value={departure_airport_code} />
                    </div>
                </div>
                <div className="two-input-container">
                    <div className="input-container">
                        <label htmlfor="arrival_airport" class="airport-name-input">* Arrival Airport</label>
                        <input id="arrival_airport" class="airport-name-input" type="text" onChange={(e) => setArrivalAirport(e.target.value)} value={arrival_airport} />
                    </div>
                    <div className="input-container">
                        <label htmlfor="arrival_airport_code" class="airport-code-input">* Arrival Airport Code</label>
                        <input id="arrival_airport_code" class="airport-code-input code-text" type="text" onChange={(e) => setArrivalAirportCode(e.target.value)} value={arrival_airport_code} />
                    </div>
                </div>
                <div className="two-input-container">
                    <div className="input-container outer-date-time-container">
                        <div className="date-time-input-container">
                            <label htmlfor="departure_date" class="label-date-time-input">* Departure Date</label>
                            <input id="departure_date" class="label-date-time-input date-input" type="date" onChange={(e) => setDepartureDate(e.target.value)} value={departure_date} />
                        </div>
                        <div className="date-time-input-container">
                            <label htmlfor="departure_time" class="label-date-time-input">* Departure Time</label>
                            <input id="departure_time" class="label-date-time-input time-input" type="time" onChange={(e) => setDepartureTime(e.target.value)} value={departure_time} />
                        </div>
                    </div>
                    <div className="input-container outer-date-time-container">
                        <div className="date-time-input-container">
                            <label htmlfor="arrival_date" class="label-date-time-input">* Arrival Date</label>
                            <input id="arrival_date" class="label-date-time-input date-input" type="date" onChange={(e) => setArrivalDate(e.target.value)} value={arrival_date} />
                        </div>
                        <div className="date-time-input-container">
                            <label htmlfor="arrival_time" class="label-date-time-input">* Arrival Time</label>
                            <input id="arrival_time" class="label-date-time-input time-input" type="time" onChange={(e) => setArrivalTime(e.target.value)} value={arrival_time} />
                        </div>
                    </div>
                </div>
                <div className="two-input-container">
                    <div className="input-container outer-flight-number-seat-container">
                        <div className="flight-number-seat-container">
                            <label htmlfor="flight_number" class="label-flight-number-seat-input">Flight Number</label>
                            <input id="flight_number" class="label-flight-number-seat-input flight-number-input" type="text" onChange={(e) => setFlightNumber(e.target.value)} value={flight_number} />
                        </div>
                        <div className="flight-number-seat-container">
                            <label htmlfor="seat_number" class="label-flight-number-seat-input">Seat Number</label>
                            <input id="seat_number" class="label-flight-number-seat-input seat-input" type="text" onChange={(e) => setSeatNumber(e.target.value)} value={seat_number} />
                        </div>
                    </div>
                    <div className="input-container">
                        <div className="outer-additional-notes-container">
                            <label htmlfor="additional_notes" class="additional-notes-label">Additional Notes</label>
                            <textarea id="additional_notes" class="additional-notes-input" onChange={(e) => setAdditionalNotes(e.target.value)} value={additional_notes}></textarea>
                        </div>
                    </div>
                </div>
                <div className="form-buttons">
                    <button type="submit" class="add-flight-btn">Update Flight</button>
                    <button type="button" class="cancel-add-flight-btn" onClick={() => onAddFlight("details")}>Cancel</button>
                </div>
            </div>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default TripUpdateFlight

